import React from 'react'
import { Badge, TakeAways, LazyLoad, SeoHelmet } from '../../common/Functions'
import Roles from './roles'
import Ecosystem from './ecosystem'

function Aims() {
  return (
   <div id="works">
    <SeoHelmet title="AIMS" description="A web application that is developed to manage alumni information, send email newsletters and generate reports for Miriam College (MC) administrators and alumni." />
    <section className="banner aims px-0">
      <div className="max-w-screen-xl	mx-auto">
        <main className="mt-10">
          <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
            <div className="lg:w-7/12 md:w-full inline-flex lg:justify-end ml-5 lg:ml-0 mt-10">
              <div className="content">
                <h1 className="text-left font-bold text-3xl text-white">
                  A web application that is developed to manage alumni information, send email newsletters and generate reports for Miriam College (MC) administrators and alumni.
                </h1>
                <p className="text-white mt-10">
                  Check how I help modernized the communication tool for the Miriam College Alumni Engagement Office.
                </p>
                <div className="roles mt-20">
                  <Badge title="Project Manager" />
                  <Badge title="UX/UI Design" />
                  <Badge title="Web Application" />
                </div>
              </div>
            </div>
            <div className="lg:w-5/12 md:w-full sm:order-first md:order-first lg:order-last flex items-center justify-center">
              <LazyLoad className="inline h-auto w-48" src={require('../../common/images/home/aims.png')} alt="AIMS Logo" />
            </div>
          </div>
        </main>
      </div>
      </section>
      <Roles />
      <Ecosystem />
      <TakeAways content="This project gave me bits of knowledge of how the alumni offices handle thousands of records in a school organization. It made me questioned for some organizations that are still on a manual-based process - how can they pull-out records and manage all the documents in paper forms? That approach is too complicated and difficult to maintain. That is why digital solutions beneficial in this era." />
   </div>
  )
}

export default Aims
